(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/betslip-error-message.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/betslip-error-message.js'); (function(Backbone, _, svs) {
  'use strict';

  svs.tipset.models.BetslipErrorMessage = Backbone.Model.extend({
    initialize: function() {
      var self = this;
      this.listenTo(
        svs.tipset.collections.matchlist,
        'buttonBet resetAll',
        this.setErrorMessage
      );
      this.listenTo(svs.tipset.models.systems, 'change', this.setErrorMessage);
      this.listenTo(
        svs.tipset.models.reduceFreeContainer,
        'change:rows',
        this.setErrorMessage
      );
      this.listenTo(
        svs.tipset.collections.matchlist,
        'buttonBet',
        this.setErrorMessage
      );
      this.listenTo(svs.tipset.models.play, 'change', function(e) {
        if (typeof e.changed.isReduceMode === 'undefined') {
          return;
        }

        if (svs.tipset.models.play.get('isSingleRow')) {
          if (!svs.tipset.collections.boardCollections) {
            return;
          }
        } else {
          if (!svs.tipset.collections.matchlist) {
            return;
          }
        }

        self.setErrorMessage();
      });
      this.setErrorMessage();
    },

    setErrorMessage: function() {
      var errMsg = '',
        hasSystem =
          svs.utils.ns.isNamespace('svs.tipset.models.systems') &&
          svs.tipset.models.systems.getCurrentSystem(),
        currentSystem,
        nrOfFullHedges,
        nrOfHalfHedges,
        nrOfRows = svs.tipset.models.play.get('isSingleRow')
          ? svs.tipset.collections.boardCollections.getNrOfRows()
          : svs.tipset.collections.matchlist.getNrOfRows(),
        selectedRows = svs.tipset.models.play.get('isReduceMode')
          ? svs.tipset.models.reduceFreeContainer.get('rows')
          : undefined,
        possibleRows = svs.tipset.models.play.get('isReduceMode')
          ? svs.tipset.collections.matchlist.getNrOfRows()
          : undefined;

      if (hasSystem) {
        currentSystem = svs.tipset.models.systems.getCurrentSystem();
        nrOfFullHedges = svs.tipset.collections.matchlist.getNrOfFullHedges();
        nrOfHalfHedges = svs.tipset.collections.matchlist.getNrOfHalfHedges();

        if (nrOfFullHedges > currentSystem.full) {
          errMsg = 'Du har gjort för många helgarderingar.';
        }
        if (nrOfHalfHedges > currentSystem.half) {
          errMsg = 'Du har gjort för många halvgarderingar.';
        }
      }
      if (
        !svs.tipset.models.play.get('isReduceMode') &&
        nrOfRows > svs.tipset.models.gameDefinitions.get('maxSystemSize')
      ) {
        errMsg =
          'Ditt system är för stort. Maxgränsen är ' +
          svs.utils.format.Currency(
            svs.tipset.models.gameDefinitions.get('maxSystemSize'),
            false
          ) +
          ' rader.';
      }

      if (svs.tipset.models.play.get('isReduceMode')) {
        if (svs.tipset.models.reduceFreeContainer.get('rows') === 0) {
          errMsg = 'Du måste fylla i antal rader du vill reducera ner till.';
        } else if (selectedRows >= possibleRows) {
          errMsg = 'Antal rader måste vara färre än antalet möjliga rader.';
        }
      }

      this.set('errorMessage', errMsg);
      this.set('hasErrorMessage', errMsg != '');
    }
  });
})(Backbone, _, svs);

 })(window);